<app-header [isScrolled]="true" [showMobilePropertySearchHeader]="true"></app-header>
<ion-content scroll-events="true" fullscreen="true"
             (ionScroll)="onScroll($event)">
  <div class="content-wrapper">
<!--    <app-listing-filter [urlParams]="param" (filterChanged)="filterValueChanged($event)"  class="ion-hide-sm-down"></app-listing-filter>-->

    <div class="listing-wrapper">
      <div class="listings" #scrollContainer>
        <virtual-scroll-element class="ion-content-scroll-host">
        @if (!isLoading()) {
          <div class="flex align-items-center ion-justify-content-between">
            <h2>{{resultsLength}} {{ 'property.properties' | translate }}</h2>
          </div>
        }
        @for (property of properties | customSort: filteredId | propertyFilter: filterQuery; let last = $last; track property) {
          <app-property-card [innerCard]="true"
                             [activeId]="filteredId"
                             [listingPage]="true"
                             [property]="property"></app-property-card>
        } @empty {
          <div class="ion-text-center ion-padding">
            <h3>{{ 'property.no_properties' | translate }}</h3>
          </div>
        }
        </virtual-scroll-element>
<!--        <ion-infinite-scroll (ionInfinite)="onIonInfinite($event, properties[properties.length - 1]._id)">-->
        <ion-infinite-scroll>
<!--          <ion-infinite-scroll-content loading-spinner="null"></ion-infinite-scroll-content>-->
        </ion-infinite-scroll>

        <div class="text-center loading-content">
          @if (properties.length < resultsLength) {
            <ion-button expand="block"
                        [disabled]="isLoadingMore()"
                        (click)="loadMoreManually()">
              @if (isLoadingMore()) {
                <ion-spinner name="crescent"></ion-spinner>
              } @else {
                {{ 'property.load_more' | translate }}
              }
            </ion-button>
          }
        </div>


      </div>
      <!-- Map removed - page redirects to external listings URL -->
    </div>
  </div>


  <app-footer></app-footer>

</ion-content>
